import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ApiBaseUrl } from '../constants/global';

const Login = () => {
  /*const apiBaseUrl = "http://localhost:3000";
  const apiBaseUrl = "https://oz-config.thinkingbigbusiness.com.au";*/
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
      const token = localStorage.getItem('token');
      if(token) {
          navigate("/");
      }
  }, [navigate]);

  const handleLogin = async (e) => {
    setLoading(true);
    e.preventDefault();
    var msgContainer = document.getElementById('page-message');
    try {
      const res = await axios.post(`${ApiBaseUrl}/login`, { email, password });
      setLoading(false);
      if (res.status === 200) {
        localStorage.setItem("token", res.data.token);
        navigate("/");
      }
    } catch (err) {
      setLoading(false);
      var htmlMsg = "Network error. Please check your connection.";
      if (err.response) {
        // If there is a response with an error status code
        const { status, data } = err.response;
        if (status === 400 || status === 401) {
          htmlMsg = data.message || "Invalid credentials";
        } else if (status === 500) {
          htmlMsg = "Server error. Please try again later.";
        } else {
          htmlMsg = "An error occurred. Please try again.";
        }
      }
      msgContainer.innerHTML = htmlMsg;
      msgContainer.style.display = "block";
      msgContainer.classList.add("error");
    }
  };

  return (
    <div className="config-main login-bkend-container">
      <h2>Login</h2>
      <div id="page-message" className="page-message"></div>
      {loading && (
          <div className="loader-overlay">
                <div className="loader"></div>
          </div>
      )}
      <form onSubmit={handleLogin}>
        <div className="field">
            <label htmlFor="login-email">Email</label>
            <input
                id="login-email"
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                required
            />
        </div>
        <div className="field">
            <label htmlFor="login-password">Password</label>
            <input
                id="login-password"
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
            />
        </div>
        <div>
          <button type="submit">Login</button>
        </div>
      </form>
    </div>
  );
};

export default Login;
